<template>
    <div v-if="isEmployee" class="punch-timer">
        <div class="pt-icon">
            <app-icon name="clock"/>
        </div>
        <div class="pt-body">
            <div class="pt-time">{{ formatted }}</div>
            <div class="pt-label">
                <span class="pt-dot" :class="{ running: isRunning }"></span>
                {{ statusLabel }}
            </div>
        </div>
    </div>
</template>

<script>
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {APP_DASHBOARD} from "../../../../Config/ApiUrl";

export default {
    name: "PunchTimer",
    data() {
        return {
            baseSeconds: 0,
            isRunning: false,
            elapsed: 0,
            ticker: null,
            resyncer: null,
        }
    },
    computed: {
        isEmployee() {
            // Show only for employees who punch in — not for super-admins.
            return !!(window.user && parseInt(window.user.is_in_employee)) && !this.$isAdmin();
        },
        displaySeconds() {
            return this.baseSeconds + (this.isRunning ? this.elapsed : 0);
        },
        formatted() {
            const total = Math.max(0, this.displaySeconds);
            const h = Math.floor(total / 3600);
            const m = Math.floor((total % 3600) / 60);
            const s = total % 60;
            const pad = n => String(n).padStart(2, '0');
            return `${pad(h)}:${pad(m)}:${pad(s)}`;
        },
        statusLabel() {
            if (this.isRunning) return 'Punched in';
            return this.baseSeconds > 0 ? 'Paused' : 'Not punched in';
        }
    },
    created() {
        if (!this.isEmployee) return;
        this.fetchWorked();
        this.ticker = setInterval(() => {
            if (this.isRunning) this.elapsed++;
        }, 1000);
        this.resyncer = setInterval(() => this.fetchWorked(), 60000);
        this.$hub.$on('reload-punch-in-out-button', this.fetchWorked);
    },
    beforeUnmount() {
        clearInterval(this.ticker);
        clearInterval(this.resyncer);
        this.$hub.$off('reload-punch-in-out-button', this.fetchWorked);
    },
    methods: {
        fetchWorked() {
            axiosGet(`${APP_DASHBOARD}/employee/worked-today`).then(({data}) => {
                this.baseSeconds = Number(data.worked_seconds) || 0;
                this.isRunning = !!data.is_running;
                this.elapsed = 0;
            }).catch(() => {
            });
        }
    }
}
</script>

<style scoped>
.punch-timer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0 14px 14px;
    padding: 10px 12px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.10);
    border-radius: 10px;
    overflow: hidden;
}

.pt-icon {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    background: linear-gradient(135deg, #2563eb, #60a5fa);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    flex: none;
}

.pt-icon :deep(svg) {
    width: 18px;
    height: 18px;
}

.pt-time {
    color: #ffffff;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.5px;
    font-variant-numeric: tabular-nums;
    line-height: 1.2;
}

.pt-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 10.5px;
    color: #9fb0d6;
}

.pt-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #6b7a9e;
    flex: none;
}

.pt-dot.running {
    background: #10b981;
    animation: pt-pulse 1.6s infinite;
}

@keyframes pt-pulse {
    0% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.5); }
    70% { box-shadow: 0 0 0 6px rgba(16, 185, 129, 0); }
    100% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }
}

/* Collapsed (icon-only) sidebar: hide the text, keep the icon */
.sidebar-icon-only .punch-timer .pt-body {
    display: none;
}

.sidebar-icon-only .punch-timer {
    justify-content: center;
    padding: 8px;
    margin: 0 10px 12px;
}
</style>
